import React, { useCallback, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { cn } from '@epoch-ui/lib/utils';
import { Separator } from '@epoch-ui/components/Separator';
import { useEditableEvent } from '@event-editor/hooks/useEditableEvent';
import { eventEditorQueryKeys } from '@event-editor/queryKeys';
import { getEventCommunication } from '@event-editor/api/get-event-communication';

import { CommunicationRemindersEmptyState } from './components/CommunicationRemindersEmptyState';
import { EditEventReminderUpsertSheet } from './components/EditEventCommunicationSideSheet/EditEventCommunicationSideSheet';
import { EpochCommunication } from './components/EpochCommunication/EpochCommunication';
import { CommunicationRemindersList } from './components/CommunicationRemindersList';

export const EditEventCommunications = (): React.ReactElement => {
  const { emailReminders, slackReminders, id, scheduledDeletionAt } = useEditableEvent();

  const isCancelled = !!scheduledDeletionAt;

  const [createEventCommunicationSideSheetOpen, setCreateEventCommunicationSideSheetOpen] =
    useState(false);

  const openCreateEventCommunicationSideSheet = useCallback(() => {
    setCreateEventCommunicationSideSheetOpen(true);
  }, []);

  const epochCommunicationQuery = useQuery({
    queryKey: eventEditorQueryKeys.eventCommunication(id!),
    queryFn: () => getEventCommunication.get({ eventId: id! }),
    enabled: !!id
  });

  return (
    <div>
      <div className={cn(isCancelled && 'tw-opacity-40')}>
        <h2 className="tw-m-0 tw-text-xl tw-font-medium tw-leading-7">Reminders</h2>
        <p className="tw-m-0 tw-mt-1 tw-text-sm tw-font-normal tw-leading-5 tw-text-primary-grey">
          Send custom reminders to guests
        </p>
      </div>
      {!emailReminders?.length && !slackReminders?.length ? (
        <CommunicationRemindersEmptyState
          openCreateEventCommunicationSideSheet={openCreateEventCommunicationSideSheet}
        />
      ) : (
        <CommunicationRemindersList
          openCreateEventCommunicationSideSheet={openCreateEventCommunicationSideSheet}
        />
      )}

      {epochCommunicationQuery.data && epochCommunicationQuery.data.notifications.length > 0 && (
        <>
          <Separator className="tw-my-10" />
          <EpochCommunication notifications={epochCommunicationQuery.data.notifications} />
        </>
      )}

      <EditEventReminderUpsertSheet
        isOpen={createEventCommunicationSideSheetOpen}
        onClose={() => setCreateEventCommunicationSideSheetOpen(false)}
      />
    </div>
  );
};
